/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M938.1 286.7L500.5 706.9c-1.4 1.4-3.2 2-5.1 2-.2 0-.3-.2-.6-.2l-163.6 42.9c-2.4.6-4.9.9-7.4.9-7.5 0-14.5-2.7-19.8-7.7-7.1-7-9.8-16.9-7.2-26.1l45-158.3c.3-.9.8-1.7 1.4-2.4.3-.5.2-1.1.6-1.5l437.5-420.4c13-12.5 30.8-19.3 50-19.3 21.8 0 43.7 8.9 59.9 24.5l41.3 39.8c16.2 15.5 25.5 36.5 25.5 57.5.2 18.5-6.9 35.6-19.9 48.1zM363.6 687.5l83.7-22-60.9-58.5-22.8 80.5zm57.5-123l71.1 68.2L807.3 330l-70.5-68.8-315.7 303.3zM893.2 219l-41.4-39.8c-7.8-7.5-20.9-8.5-27.7-1.9l-42.8 41.2 70.5 68.8 43.5-41.7c3-2.9 4.7-7 4.7-11.4 0-5.6-2.5-11.1-6.8-15.2zm-284.8-62.9H164c-21.4 0-38.8 16.7-38.8 37.3v639.5c0 20.5 17.4 37.2 38.8 37.2h690c21.4 0 38.8-16.7 38.8-37.2V441.1c0-16.1 13.6-29.1 30.2-29.1s30.1 12.9 30.2 28.9v396.4c0 50.1-42.4 90.8-94.6 90.8H159.4c-52.2 0-94.6-40.7-94.6-90.8V189c0-50.1 42.4-90.9 94.6-90.9h449c16.7 0 30.2 13 30.2 29s-13.6 29-30.2 29z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/edit.js